import React, { useEffect } from "react";
import { UserProvider } from "contexts/UserContext";
import { AuthProvider, useAuth } from "contexts/AuthContext";
import { TeamProvider, useTeam } from "contexts/TeamContext";
import { CauseProvider } from "contexts/CauseContext";
import { SubscriptionProvider } from "contexts/SubscriptionContext";

// TeamContext is plain in-memory state with no persistence of its own, so a
// page reload wiped organizationId/teamId even though the account still has
// a real organization on the backend (AuthContext.accountOrganizationId is
// the one that survives a reload, since it's refetched from /account). This
// restores TeamContext from it so screens gating on teamId/organizationId
// (e.g. Home's "new user" upsell) don't misfire after a refresh.
const TeamBootstrap = ({ children }) => {
  const { accountOrganizationId, isAccountLoading } = useAuth();
  const { organizationId, setOrganizationId, teams, teamId, setTeamId, setTeamName } =
    useTeam();

  useEffect(() => {
    if (isAccountLoading) return;
    if (accountOrganizationId && accountOrganizationId !== organizationId) {
      setOrganizationId(accountOrganizationId);
    }
  }, [accountOrganizationId, isAccountLoading, organizationId, setOrganizationId]);

  useEffect(() => {
    if (teamId) return;
    if (Array.isArray(teams) && teams.length > 0) {
      setTeamId(teams[0].id);
      setTeamName(teams[0].name);
    }
  }, [teams, teamId, setTeamId, setTeamName]);

  return children;
};

const AppProvider = ({ children }) => {
  return (
    <SubscriptionProvider>
      <AuthProvider>
        <TeamProvider>
          <TeamBootstrap>
            <CauseProvider>
              <UserProvider>{children}</UserProvider>
            </CauseProvider>
          </TeamBootstrap>
        </TeamProvider>
      </AuthProvider>
    </SubscriptionProvider>
  );
};

export default AppProvider;
